import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import {parseSchool} from '@freckle/educator-entities/ts/roster/models/school'

const toApiFormat = (school: SchoolAttrs) => ({
  ...school,
  licenseUtilizationNotificationsMutedAt:
    school.licenseUtilizationNotificationsMutedAt?.toISOString(),
  renaissanceSchoolClient:
    school.renaissanceSchoolClient !== null && school.renaissanceSchoolClient !== undefined
      ? {
          ...school.renaissanceSchoolClient,
          platform: school.renaissanceSchoolClient.platform as
            'renaissance_place' | 'renaissance_growth_platform'
        }
      : null
})

export const updateSchool = (schoolId: number, updatedSchool: SchoolAttrs): Promise<SchoolAttrs> =>
  fancyClient
    .PATCH('/2/schools/{SchoolP-SchoolId}', {
      params: {path: {'SchoolP-SchoolId': schoolId}},
      body: toApiFormat(updatedSchool)
    })
    .then(extractData)
    .then(parseSchool)
